import Icon from "./logo";
import { createAsideSnippet, createFooterSnippet, createHeaderSnippet, getObjectSetterSnippet } from "../../common/manager/setter-snippet";
import { PAGE_ASIDE, PAGE_CONTENT } from "../../common/util/const";
var CnLayoutPagePrototype = {
  title: '自然布局页面',
  componentName: 'CnLayoutPage',
  icon: Icon,
  docUrl: '',
  // category: '图表',
  isContainer: true,
  disableBehaviors: '*',
  initialChildren: [{
    componentName: 'CnLayoutContent',
    props: {
      isCnLayoutContent: true
      // "_context": {
      //   "type": "JSExpression",
      //   "value": "this"
      // }
    }
  }],

  configure: [{
    name: 'isCnLayoutPage',
    title: 'CnLayoutPage',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }, {
    title: '样式',
    display: 'accordion',
    collapsed: false,
    setter: getObjectSetterSnippet({
      items: [{
        name: 'header',
        title: '开启页头',
        display: 'inline',
        setter: 'BoolSetter',
        extraProps: {
          // getValue: (target) => {
          //   // const pageNode = target.node;
          //   // return !!pageNode?.children?.find((n) => n.componentName === PAGE_HEADER);
          // },
          setValue: function setValue(target, value) {
            var _pageNode$children;
            var pageNode = target.node;
            var node = pageNode === null || pageNode === void 0 ? void 0 : (_pageNode$children = pageNode.children) === null || _pageNode$children === void 0 ? void 0 : _pageNode$children.find(function (n) {
              return n.componentName === 'CnLayoutHeader';
            });
            if (value && !node) {
              var _pageNode$document, _pageNode$children2;
              var navSnippets = createHeaderSnippet();
              var node2 = pageNode === null || pageNode === void 0 ? void 0 : (_pageNode$document = pageNode.document) === null || _pageNode$document === void 0 ? void 0 : _pageNode$document.createNode(navSnippets);
              var insertNode = pageNode === null || pageNode === void 0 ? void 0 : (_pageNode$children2 = pageNode.children) === null || _pageNode$children2 === void 0 ? void 0 : _pageNode$children2.get(0);
              node2 && insertNode && (pageNode === null || pageNode === void 0 ? void 0 : pageNode.insertBefore(node2, insertNode, false));
            } else if (!value && node) {
              node.remove();
            }
          }
        }
      }, {
        name: 'footer',
        title: '开启页尾',
        display: 'inline',
        setter: 'BoolSetter',
        extraProps: {
          // getValue: (target) => {
          //   // const pageNode = target.node;
          //   // return !!pageNode?.children?.find((n) => n.componentName === PAGE_HEADER);
          // },
          setValue: function setValue(target, value) {
            var _pageNode$children3;
            var pageNode = target.node;
            var node = pageNode === null || pageNode === void 0 ? void 0 : (_pageNode$children3 = pageNode.children) === null || _pageNode$children3 === void 0 ? void 0 : _pageNode$children3.find(function (n) {
              return n.componentName === 'CnLayoutFooter';
            });
            if (value && !node) {
              var _pageNode$document2;
              var navSnippets = createFooterSnippet();
              var node2 = pageNode === null || pageNode === void 0 ? void 0 : (_pageNode$document2 = pageNode.document) === null || _pageNode$document2 === void 0 ? void 0 : _pageNode$document2.createNode(navSnippets);
              node2 && (pageNode === null || pageNode === void 0 ? void 0 : pageNode.insertBefore(node2));
            } else if (!value && node) {
              node.remove();
            }
          }
        }
      }, {
        name: 'aside',
        title: '开启侧边栏',
        display: 'inline',
        setter: 'BoolSetter',
        extraProps: {
          // getValue: (target) => {
          //   // const pageNode = target.node;
          //   // return !!pageNode?.children?.find((n) => n.componentName === PAGE_HEADER);
          // },
          setValue: function setValue(target, value) {
            var _pageNode$children4;
            var pageNode = target.node;
            var node = pageNode === null || pageNode === void 0 ? void 0 : (_pageNode$children4 = pageNode.children) === null || _pageNode$children4 === void 0 ? void 0 : _pageNode$children4.find(function (n) {
              return n.componentName === PAGE_CONTENT;
            });
            if (node) {
              if (value) {
                var _pageNode$document3;
                var asideSnippets = createAsideSnippet();
                var node2 = pageNode === null || pageNode === void 0 ? void 0 : (_pageNode$document3 = pageNode.document) === null || _pageNode$document3 === void 0 ? void 0 : _pageNode$document3.createNode(asideSnippets);
                node2 && (pageNode === null || pageNode === void 0 ? void 0 : pageNode.insertBefore(node2));
              } else {
                var _pageNode$children5, _pageNode$children5$f, _pageNode$children5$f2;
                var asideNode = pageNode === null || pageNode === void 0 ? void 0 : (_pageNode$children5 = pageNode.children) === null || _pageNode$children5 === void 0 ? void 0 : (_pageNode$children5$f = _pageNode$children5.find(function (n) {
                  return n.componentName === PAGE_ASIDE;
                })) === null || _pageNode$children5$f === void 0 ? void 0 : (_pageNode$children5$f2 = _pageNode$children5$f.getNode) === null || _pageNode$children5$f2 === void 0 ? void 0 : _pageNode$children5$f2.call(_pageNode$children5$f);
                asideNode === null || asideNode === void 0 ? void 0 : asideNode.remove();
              }
            }
          }
        }
      }]
    })
  }
  // {
  //   type: 'group',
  //   title: {
  //     label: '选项卡样式',
  //   },
  //   extraProps: {
  //     display: 'block',
  //   },
  //   items: [
  //     {
  //       name: 'minHeight',
  //       title: {
  //         label: '最小高度',
  //       },
  //       display: 'inline',
  //       initialValue: '100vh',
  //       defaultValue: '100vh',
  //       setter: {
  //         componentName: 'StringSetter',
  //       },
  //     },
  //   ],
  // }
  ]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutPagePrototype };